import {ActionIcon, Flex} from "@mantine/core";
import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {IconSearch} from "@tabler/icons-react";
import {AllocatableLoadInventorySnapshotEntity, TransportCategory} from "@ots-frontend/ots-data";
import {useAvailableLoadsByTimeInsight} from "./useAvailableLoadsByTimeInsight";
import {InsightBarChart, InsightBarChartProps} from "../InsightBarChart/InsightBarChart";
import {InsightLineChart, InsightLineChartProps} from "../InsightLineChart/InsightLineChart";
import { InsightTimeChart } from "../InsightTimeChart/InsightTimeChart";

export type AvailableLoadsByTimeProps =
  Omit<(InsightBarChartProps | InsightLineChartProps), 'title' | 'xAxisTitle' | 'yAxisTitle' | 'data'>
  & {
  fromDttm: number
  toDttm?: number
  data?: AllocatableLoadInventorySnapshotEntity[]
  category?: TransportCategory,
  showEmpty?: boolean
  showSearch?: boolean
  type?: string
}

export const AvailableLoadsByTimeInsight = (props: AvailableLoadsByTimeProps) => {
  const {
    fromDttm,
    toDttm = new Date().getTime(),
    data,
    category,
    showEmpty = true,
    showSearch = false,
    type = "line",
    ...rest
  } = props

  const {t} = useTranslation()
  const navigate = useNavigate()

  const title = t<string>("common.insight.availableloadsbytime", "Avail. Loads By Time")

  const {chartData} = useAvailableLoadsByTimeInsight({
    fromDttm,
    toDttm,
    data,
    category,
  })

  if (showEmpty && (!chartData || chartData.titles.length === 0)) {
    return (
      <InsightEmpty {...rest} title={title}>
        {showSearch &&
          <Flex justify="flex-end">
            <ActionIcon onClick={() => navigate("/insights/available-loads-by")}>
              <IconSearch size="1.125rem"/>
            </ActionIcon>
          </Flex>
        }
      </InsightEmpty>
    )
  }

  if (type === 'bar') {
    return (
      <InsightBarChart
        {...rest}
        title={title}
        xAxisTitle={t<string>("common.insight.availableloadsbytime.xaxis.title", "Time")}
        yAxisTitle={t<string>("common.insight.availableloadsbytime.yaxis.title", "# of Loads")}
        data={chartData}>
        {showSearch &&
          <Flex justify="flex-end">
            <ActionIcon onClick={() => navigate("/insights/available-loads-by")}>
              <IconSearch size="1.125rem"/>
            </ActionIcon>
          </Flex>
        }
      </InsightBarChart>
    )
  } else {
    return (
      <InsightTimeChart
        {...rest}
        title={title}
        xAxisTitle={t<string>("common.insight.availableloadsbytime.xaxis.title", "Time")}
        yAxisTitle={t<string>("common.insight.availableloadsbytime.yaxis.title", "# of Loads")}
        data={chartData}>
        {showSearch &&
          <Flex justify="flex-end">
            <ActionIcon onClick={() => navigate("/insights/available-loads-by")}>
              <IconSearch size="1.125rem"/>
            </ActionIcon>
          </Flex>
        }
      </InsightTimeChart>
    )
  }
}
